import { Vermittlernummer } from '@ps20/bff-models';

const vermittlernummerSeparator = '/';

function isStringEmpty(value: string): boolean {
  return value == null || value.trim().length === 0;
}

export function convertVermittlernummerToString(vermittlernummer: Vermittlernummer): string {
  if (
    vermittlernummer == null ||
    (isStringEmpty(vermittlernummer.zweigniederlassung) &&
      isStringEmpty(vermittlernummer.vertreternummer) &&
      isStringEmpty(vermittlernummer.geschaeftsstelle))
  ) {
    return '';
  }
  return (
    `${vermittlernummer.zweigniederlassung}` +
    `${vermittlernummer.geschaeftsstelle ? vermittlernummerSeparator : ''}${
      vermittlernummer.geschaeftsstelle
    }` +
    `${vermittlernummer.vertreternummer ? vermittlernummerSeparator : ''}${
      vermittlernummer.vertreternummer
    }`
  );
}

export function isVermittlernummerValid(vermittlernummer: Vermittlernummer): boolean {
  return (
    vermittlernummer &&
    !(
      isStringEmpty(vermittlernummer.zweigniederlassung) ||
      isStringEmpty(vermittlernummer.vertreternummer) ||
      isStringEmpty(vermittlernummer.geschaeftsstelle)
    )
  );
}

export function convertVermittlernummerStringToObject(vermittlernummer: string): Vermittlernummer {
  const values = vermittlernummer.split(vermittlernummerSeparator);
  return {
    zweigniederlassung: values[0] ? values[0] : '',
    geschaeftsstelle: values[1] ? values[1] : '',
    vertreternummer: values[2] ? values[2] : '',
  };
}

export function getBgvg(zweigniederlassung: string): string {
  return zweigniederlassung.charAt(1) === '0'
    ? zweigniederlassung.charAt(0)
    : zweigniederlassung.charAt(1);
}
